import React, { useState } from "react";

import Banner from "../components/Banner";
import Donation from "../components/Donations";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import ProjectComp from "../components/ProjectComponent";
import Support from "../components/Support";
import landingAsset from "../utils/assetPaths";

interface CharityButton {
    label: string;
    value: string;
    component: React.ReactNode;
}

const Charity: React.FC = () => {
    const [activeButton, setActiveButton] = useState("support");

    const buttons: CharityButton[] = [
        {
            label: "Financial Support",
            value: "support",
            component: <Support />,
        },

        {
            label: "Gift Donation",
            value: "donation",
            component: <Donation />,
        },
    ];

    const handleButtonClick = (value: string) => {
        setActiveButton(value);
    };

    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">SACA Football Foundation</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            Support sports development in the UK & Africa through donations to
                            the SACA Football Foundation.
                        </p>
                    </div>
                </div>
            </div>

            <div className=" flex flex-col items-center py-20 w-full px-4 md:px-14 bg-gray-50">
                <div className="max-w-4xl w-full mx-auto">
                    <div className=" bg-white p-8 md:p-12 rounded-[40px] shadow-xl border border-gray-100">
                        <div className="mb-10 text-center md:text-left">
                            <h3 className=" font-Manrope text-3xl font-black text-gray-900">
                                Make a Difference
                            </h3>
                            <p className=" mt-3 text-lg font-Manrope font-medium text-gray-500">
                                Your generosity fuels our mission to bring football to everyone.
                            </p>
                        </div>

                        <div className="flex mb-10 border-b-2 border-gray-100 w-full">
                            {buttons.map((button, index) => (
                                <button
                                    key={index}
                                    className={`font-black font-Manrope text-sm md:text-base pb-6 px-8 transition-all relative ${activeButton === button.value
                                        ? "text-green-700 border-b-4 border-green-700 -mb-[4px]"
                                        : "text-gray-400 hover:text-gray-600"
                                        }`}
                                    onClick={() => handleButtonClick(button.value)}
                                >
                                    {button.label}
                                </button>
                            ))}
                        </div>

                        <div className=" mt-8">
                            {buttons.find((button) => button.value === activeButton)?.component}
                        </div>
                    </div>
                </div>
            </div>

            <ProjectComp />

            <Banner />
            <Footer />
        </>
    );
};

export default Charity;
